import { render, staticRenderFns } from "./RuleType2.vue?vue&type=template&id=4141d257&scoped=true"
import script from "./RuleType2.vue?vue&type=script&lang=js"
export * from "./RuleType2.vue?vue&type=script&lang=js"
import style0 from "./RuleType2.vue?vue&type=style&index=0&id=4141d257&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141d257",
  null
  
)

export default component.exports